import { useQueryClient } from '@tanstack/react-query';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { useEffect } from 'react';
import { useUserInfo } from 'Store/userInfo';

import useMonitoringState from 'View/monitoring/state';

import checkIsOpenConnection from './helper/checkIsOpenConnection';
import getUrlConnection from './helper/getUrlConnection';
import eventHandler from './helper/eventHandler';
import { isEmpty } from 'lodash';

const ServerSentEvent = ({ children }) => {
  const { monitoringStatus } = useMonitoringState();
  const queryClient = useQueryClient();
  const { userIdentity, token } = useUserInfo();

  useEffect(() => {
    const isOpenConnection = checkIsOpenConnection({ monitoringStatus, userIdentity });
    const connectionUrl = getUrlConnection(monitoringStatus);

    let eventSourceOperator;

    if (isEmpty(userIdentity)) return;

    if (isOpenConnection && connectionUrl) {
      const eventSourceOperator = new EventSourcePolyfill(connectionUrl, { headers: { Authorization: `Bearer ${token}` } });

      eventSourceOperator.addEventListener('general-event', (response) => eventHandler({ response, queryClient }));
    } else {
      eventSourceOperator?.close();
      eventSourceOperator?.removeEventListener('general-event', (response) => eventHandler({ response, queryClient }));
    }

    return () => {
      eventSourceOperator?.close();
      eventSourceOperator?.removeEventListener('general-event', (response) => eventHandler({ response, queryClient }));
    };

    /* eslint-disable */
  }, [monitoringStatus, userIdentity, token]);

  return children;
};

export default ServerSentEvent;
